import React from 'react'

export const FeaturesContext = React.createContext(null)
export const FeaturesProvider = FeaturesContext.Provider
export const FeaturesConsumer = FeaturesContext.Consumer
